import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '../lib/utils';
import { IconTick } from '../../assets/images';
import styles from './index.module.scss';

export default function Checkbox({ id, checked, disabled, onCheckedChange, className, indicatorClassName, jestId }) {
    return (
        <CheckboxPrimitive.Root
            id={id}
            data-jest-id={jestId}
            checked={checked}
            disabled={disabled}
            onCheckedChange={onCheckedChange}
            className={cn(styles.checkbox, className)}
        >
            <CheckboxPrimitive.Indicator className={cn(styles.indicator, indicatorClassName)}>
                <IconTick style={{ height: '0.6rem', width: '0.6rem' }} />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
}
